import { render } from "./ListOrigenes.vue?vue&type=template&id=17415d32"
import script from "./ListOrigenes.vue?vue&type=script&lang=js"
export * from "./ListOrigenes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__